import $axios from 'axios'
import qs from 'qs'
import store from '../vuex/store'

function get (url, params, isHead, dataBack, catchBack) {
  var headers = ''
  if (isHead === 'headers') {
    var token = store.state.accessToken
    headers = {
      'accessToken': token,
      'Content-Type': 'application/json'
    }
  }
  let config = {
      // 请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
    url: url,
      // 请求方法同上
    method: 'get', // default
      // 基础url前缀
    baseURL: store.state.httpHost,
  // 请求头信息
    headers: headers,
      // parameter参数
    params: params,
      // 设置超时时间
    timeout:60000,
    withCredentials: false,
      // 返回数据类型
    responseType: 'json' // default
  }
  $axios.get(url, config).then(function (res) {
    dataBack(res.data)
  }).catch(function (err) {
    if (catchBack){
      catchBack(err)
    }else{
      console.log(err);
    }
    
  })
}

function post (url, data, isHead, dataBack, catchBack) {
  var headers = ''
  if (isHead === 'headers') {
    var token = store.state.accessToken
    headers = {
      'accessToken': token,
      'Content-Type': 'application/json'
    }
  }
  let config = {
      // 请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
    url: url,
      // 请求方法同上
    method: 'post', // default
    data: qs.stringify(data),
      // 基础url前缀
    baseURL: store.state.httpHost,
  // 请求头信息
    headers: headers,
      // parameter参数
      // post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
  // data: data,
      // 设置超时时间
    timeout: 60000,
      // 返回数据类型
    responseType: 'json' // default
  }
  return $axios.post(url, data, config).then(function (res) {
    dataBack(res.data)
  }).catch(function (err) {
    catchBack(err)
  })
}

export default {
  get,
  post
}



// WEBPACK FOOTER //
// ./src/https/config.js